import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../Profile.css';
import auth from '../../services/util/auth';

const ViewCareerPathway = props => {
  const frameworkName = props.location.pathname.split('/')[2];
  const frameworkVersion = props.location.pathname.split('/')[3];
  const node_id = props.location.pathname.split('/')[5];
  const [careerPathway, setCareerPathway] = useState();
  const [userFrameworks, setUserFrameworks] = useState(null);

  var user_roles = auth.currently_logged_in_user.roles;
  var userName = auth.currently_logged_in_user.username;

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetch(
          `https://cms.competency.ebi.ac.uk/api/${frameworkName}/${frameworkVersion}/career-pathways?_format=json&nid=${node_id}&timestamp=${Date.now()}`
        )
          .then(Response => Response.json())
          .then(findresponse => {
            setCareerPathway(findresponse);
          });

        if (userName) {
          await fetch(
            `https://cms.competency.ebi.ac.uk/api/authorisation/${userName}?_format=json`,
            {
              method: 'GET',
              credentials: 'include'
            }
          )
            .then(Response => Response.json())
            .then(findresponse => {
              setUserFrameworks(findresponse);
            });
        }
      } catch (e) {
        console.log(e.message);
      }
    };

    fetchData();
  }, [frameworkName, frameworkVersion, node_id, userName]);

  return (
    <div>
      {careerPathway && (
        <div>
          {userFrameworks &&
          frameworkName &&
          user_roles.includes('framework_manager') &&
          userFrameworks.length > 0 &&
          userFrameworks.filter(frm => frm.framework === frameworkName) ? (
            <span style={{ float: 'right' }}>
              <Link
                to={`/framework/${frameworkName}/${frameworkVersion}/career-pathway/${
                  careerPathway[0].id
                }/edit`}
                className="vf-link"
              >
                Edit career pathway
              </Link>
            </span>
          ) : (
            ''
          )}
          <div className="vf-u-padding__top--800" />
          <h2>Career pathway</h2>
          <h3>{careerPathway[0].title}</h3>
          <p>{careerPathway[0].description}</p>
          {careerPathway[0].profiles && careerPathway[0].profiles.length > 0 ? (
            <div>
              <div className="career-timeline">
                {careerPathway[0].profiles.map((profile, index) => (
                  // <li key={index}>{profile.job_title}</li>
                  <article
                    key={profile.id}
                    className="vf-profile vf-profile--small vf-profile--block timeline-item"
                  >
                    {/* <div className="timeline-marker" /> */}
                    <div className="timeline-content">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`/framework/${frameworkName}/${frameworkVersion}/profile/view/${
                          profile.id
                        }${profile.url_alias}`}
                        className="vf-link"
                      >
                        <center>
                          <img
                            alt=""
                            src={profile.image[0] ? profile.image[0].url : ''}
                            width={'60px'}
                            height={'auto'}
                            loading="lazy"
                            className="vf-profile__image"
                          />
                        </center>
                        <h4 className="vf-profile__title">
                          {' '}
                          {profile.job_title}
                        </h4>
                      </a>

                      <p className="vf-profile__text">
                        {profile.seniroty_level
                          ? profile.seniroty_level
                          : `Step ${index + 1}`}
                      </p>
                    </div>
                    {/* Draw connecting line except for last item */}
                    {index < careerPathway[0].profiles.length - 1 && (
                      <div className="timeline-line" />
                    )}
                  </article>
                ))}
              </div>
            </div>
          ) : (
            <p>No associated profiles.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ViewCareerPathway;
